import { CoreConstants } from '../core.constants';
import { Observable, throwError } from 'rxjs';
import * as CryptoJS from 'crypto-js';
import jwt_decode from 'jwt-decode';
import { MatDialogConfig } from '@angular/material/dialog';
import * as moment from 'moment';

export class Utility {
  public static getDialogData(data?: any, disableClose: boolean = true, closeOnNavigation: boolean = true, dialogConfig?: MatDialogConfig): MatDialogConfig {
    let config = new MatDialogConfig();
    if (dialogConfig) {
      config = {...dialogConfig};
    }
    config.panelClass = 'mat-dialog-mini-content';
    if (data) {
      config.data = data;
    }
    if (disableClose) {
      config.disableClose = disableClose;
    }
    if (closeOnNavigation) {
      config.closeOnNavigation = closeOnNavigation;
    }
    return config;
  }

  public static getDialogDataFullScreen(data?: any, disableClose: boolean = true, closeOnNavigation: boolean = true): MatDialogConfig {
    const config = new MatDialogConfig();
    config.panelClass = 'mat-large-size-dialog';
    if (data) {
      config.data = data;
    }
    if (disableClose) {
      config.disableClose = disableClose;
    }
    if (closeOnNavigation) {
      config.closeOnNavigation = closeOnNavigation;
    }
    return config;
  }

  public static getDialogDataMediumScreen(data?: any, disableClose: boolean = true, closeOnNavigation: boolean = true): MatDialogConfig {
    const config = new MatDialogConfig();
    config.panelClass = 'mat-medium-size-dialog';
    if (data) {
      config.data = data;
    }
    if (disableClose) {
      config.disableClose = disableClose;
    }
    if (closeOnNavigation) {
      config.closeOnNavigation = closeOnNavigation;
    }
    return config;
  }

  public static getDeleteMessage(): any {
    return {
      title: 'CONSTANTS.DELETE.TITLE',
      message: 'CONSTANTS.DELETE.MESSAGE',
    };
  }

  public static resizeWindow(): void {
    // window.dispatchEvent(new Event('resize'));
    const resizeEvent = window.document.createEvent('UIEvents') as any;
    resizeEvent.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(resizeEvent);
  }

  public static scrollTo(attr: string): void {
    setTimeout(() => {
      const elementList = document.querySelectorAll(attr);
      const element = elementList[0] as HTMLElement;
      element.scrollIntoView({behavior: 'smooth', block: 'start'});
    }, 500);
  }

  public static getConfirmationMessage(): any {
    return {
      title: 'CONSTANTS.CONFIRMATION.TITLE',
      message: 'CONSTANTS.CONFIRMATION.MESSAGE',
    };
  }

  public static scrollOnInvalidField(): void {
    const invalidElements = Array.from(document.querySelectorAll('.ng-invalid , .button-controls'));
    /*const buttonControls = Array.from(document.querySelectorAll('.button-controls'));
    invalidElements.push(...buttonControls);*/
    let control = null;
    // for-of wont work here
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < invalidElements.length; i++) {
      if (invalidElements[i].getAttribute('type') === 'checkbox') {
        control = invalidElements[i];
        break;
      } else if (invalidElements[i].getAttribute('type') === 'radio') {
        control = invalidElements[i].parentElement.parentElement.parentElement;
        break;
      } else if (invalidElements[i].parentElement.classList.contains('form-group')) {
        if (invalidElements[i].classList.contains('button-controls')) {
          let flag = false;
          // for-of wont work here
          // tslint:disable-next-line:prefer-for-of
          for (let j = 0; j < invalidElements[i]?.children.length; j++) {
            if (!(invalidElements[i]?.children[j].className.includes('disabled'))) {
              flag = true;
            }
          }
          if (!flag) {
            control = invalidElements[i].parentElement;
            break;
          }
        } else {
          control = invalidElements[i];
          break;
        }
      } else if (invalidElements[i].classList.contains('ngbDate')) {
        control = invalidElements[i];
        break;
      }
    }
    if (control?.tagName === 'TEXTAREA') {
      control.parentElement.focus();
    } else if (control?.name) {
      document.getElementsByName(control?.name)[0].parentElement.focus();
    } else if (control?.classList.contains('file-upload')) {
      control.parentElement.focus();
    } else if (control?.classList.contains('chips')) {
      control.parentElement.focus();
    } else if (control?.classList.contains('ngbDate')) {
      control.focus();
    } else if (control?.classList.contains('ng-select')) {
      control.parentElement.focus();
    }  /*else {
      control.focus();
    }*/
  }


  public static decrypt(textToDecrypt: string): Observable<any> {
    return new Observable<any>((observer: any): any => {
      if (!CoreConstants.encryptionKey || !CoreConstants.encryptionIV) {
        throwError('Encryption Config Missing !');
      }
      try {
        const key = CryptoJS.enc.Base64.parse(CoreConstants.encryptionKey);
        const iv = CryptoJS.enc.Utf8.parse(CoreConstants.encryptionIV);
        const decrypted = CryptoJS.AES.decrypt(textToDecrypt, key, {
          iv,
          mode: CryptoJS.mode.CBC,
        });
        observer.next(JSON.parse(decrypted.toString(CryptoJS.enc.Utf8)));
        observer.complete();
      } catch (e) {
        observer.error('Decryption Failed');
      }
    });

  }

  public static decodeHtml(value: string): string {
    if (value && value.length > 0) {
      const dom = new DOMParser().parseFromString(value, 'text/html');
      return dom.body.textContent;
    }
    return '';
  }

  public static setEncriptionKey(token: string): void {
    try {
      const decoded = jwt_decode(token);
      CoreConstants.encryptionKey = decoded['hhk365nlnk'];
    } catch (e) {
      console.log(e);
    }
  }

  public static getFilterDate(date: Date, type: 'start' | 'end' = 'start'): Date {
    if (type === 'start') {
      const fromDate = new Date(date);
      fromDate.setHours(0, 0, 0, 0);
      date = fromDate;
    }
    if (type === 'end') {
      const toDate = new Date(date);
      toDate.setHours(23, 59, 59, 999);
      date = toDate;
    }
    return date;
  }


  public static getGenerateModule(module, isPlant = false): any {
    const request = {} as any;
    switch (module) {
      case CoreConstants.networkLogModules.network_log_widget:
        request.fromDate = Utility.getFilterDate(moment().toDate(), 'start') as any;
        request.toDate = Utility.getFilterDate(moment().toDate(), 'end') as any;
        request.module = module;
        request.call = true;
        break;
      case CoreConstants.networkLogModules.network_log_widget_15min:
        request.fromDate = Utility.getFilterDate(moment().subtract(7, 'day').toDate(), 'start') as any;
        request.toDate = Utility.getFilterDate(moment().toDate(), 'end') as any;
        request.module = CoreConstants.networkLogModules.network_log_widget_1hour;
        request.call = true;
        break;
      case CoreConstants.networkLogModules.network_log_widget_1hour:
        request.fromDate = Utility.getFilterDate(moment().subtract(1, 'month').toDate(), 'start') as any;
        request.toDate = Utility.getFilterDate(moment().toDate(), 'end') as any;
        request.module = module;
        request.call = true;
        break;
      case CoreConstants.networkLogModules.network_log_widget_1day:
        request.fromDate = Utility.getFilterDate(moment().subtract(1, 'year').toDate(), 'start') as any;
        request.toDate = Utility.getFilterDate(moment().toDate(), 'end') as any;
        request.module = module;
        request.call = true;
        break;
      case CoreConstants.networkLogModules.plant_log_5_min:
        const date = moment();
        request.fromDate = Utility.getFilterDate(date.toDate(), 'start') as any;
        request.toDate = Utility.getFilterDate(date.toDate(), 'end') as any;
        request.module = module;
        request.call = true;
        break;
      case CoreConstants.networkLogModules.plant_log_widget_15min:
        request.fromDate = Utility.getFilterDate(moment().subtract(7, 'day').toDate(), 'start') as any;
        request.toDate = Utility.getFilterDate(moment().toDate(), 'end') as any;
        request.module = CoreConstants.networkLogModules.plant_log_widget_1hour;
        request.call = true;
        break;
      case CoreConstants.networkLogModules.plant_log_widget_1hour:
        request.fromDate = Utility.getFilterDate(moment().subtract(1, 'month').toDate(), 'start') as any;
        request.toDate = Utility.getFilterDate(moment().toDate(), 'end') as any;
        request.module = module;
        request.call = true;
        break;
      case CoreConstants.networkLogModules.plant_log_widget_1day:
        request.fromDate = Utility.getFilterDate(moment().subtract(1, 'year').toDate(), 'start') as any;
        request.toDate = Utility.getFilterDate(moment().toDate(), 'end') as any;
        request.module = module;
        request.call = true;
        break;
      default:
        if (isPlant) {
          request.fromDate = Utility.getFilterDate(moment().toDate(), 'start') as any;
          request.toDate = Utility.getFilterDate(moment().toDate(), 'end') as any;
          request.module = CoreConstants.networkLogModules.plant_log_5_min;
        } else {
          request.fromDate = Utility.getFilterDate(moment().toDate(), 'start') as any;
          request.toDate = Utility.getFilterDate(moment().toDate(), 'end') as any;
          request.module = CoreConstants.networkLogModules.network_log_widget;
        }
        break;
    }
    return request;
  }

  public static getGenerateModuleDateSelectionChange(fromDate, toDate, isPlant = false): any {
    const request = {} as any;
    if (fromDate && toDate) {
      request.fromDate = Utility.getFilterDate(moment(fromDate).toDate(), 'start') as any;
      request.toDate = Utility.getFilterDate(moment(toDate).toDate(), 'end') as any;
      const differenceInDays = moment().diff(moment(fromDate), 'days');
      if (differenceInDays === 0) {
        if (isPlant) {
          request.module = CoreConstants.networkLogModules.plant_log_5_min;
        } else {
          request.module = CoreConstants.networkLogModules.network_log_widget;
        }
      } else if (differenceInDays <= 7) {
        if (isPlant) {
          request.module = CoreConstants.networkLogModules.plant_log_widget_15min;
        } else {
          request.module = CoreConstants.networkLogModules.network_log_widget_15min;
        }
      } else if (differenceInDays <= 30) {
        if (isPlant) {
          request.module = CoreConstants.networkLogModules.plant_log_widget_1hour;
        } else {
          request.module = CoreConstants.networkLogModules.network_log_widget_1hour;
        }
      } else {
        if (isPlant) {
          request.module = CoreConstants.networkLogModules.plant_log_widget_1day;
        } else {
          request.module = CoreConstants.networkLogModules.network_log_widget_1day;
        }
      }
    }
    return request;
  }


  public static nFormatter(num) {
    if (num >= 1000000000) {
      return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'G';
    }
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    }
    if (num >= 1000) {
      return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
    }
    return num;
  }
}
